import ar from "./ar.json";
import bg from "./bg.json";
import cs from "./cs.json";
import de from "./de.json";
import en from "./en.json";
import el from "./el.json";
import es from "./es.json";
import fr from "./fr.json";
import ko from "./ko.json";
import pl from "./pl.json";
import pt from "./pt.json";
import ru from "./ru.json";
import it from "./it.json";

const supportedLanguage = {
  ar,
  bg,
  cs,
  de,
  en,
  el,
  es,
  fr,
  it,
  ko,
  pl,
  pt,
  ru,
};

export default supportedLanguage;
